// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"558":"e14afdb6","661":"e14afdb6","943":"e14afdb6"}[chunkId] + ".chunk.css";
};